@if (userInfo) {
  <div class="d-flex align-items-center local-card-width">
    <sk-user-avatar
      [avatarSize]="'lg'"
      [userInfo]="userInfo()"
      [avatarUrl]="avatarUrl()"
    ></sk-user-avatar>

    <div class="d-flex flex-column local-fields ml-2">
      <p class="fw-bold mb-0">
        {{userInfo().firstname}} {{userInfo().lastname}}
      </p>
      @if (userInfo().phone) {
        <a class="local-phone-field"
           href="tel:{{userInfo().phone}}"
           data-test="user-link">
          <i class="fas fa-sm fa-phone"></i>

          <span class="local-phone-number ml-1">
            {{userInfo().phone}}
          </span>
        </a>
      }

      @if (userInfo().mobileNumber) {
        <a class="local-phone-field"
           href="tel:{{userInfo().mobileNumber}}"
           data-test="user-link-2">
          <i class="fas fa-sm fa-phone"></i>

          <span class="local-phone-number ml-1">
            {{userInfo().mobileNumber}}
          </span>
        </a>
      }

      @if (userInfo().email) {
        <a class="local-email-field"
           href="mailto:{{userInfo().email}}"
           data-test="user-link-3">
          {{userInfo().email}}
        </a>
      }
    </div>
  </div>
}
